/**
 * @description 考试，问卷，作业提交时间设置 封装的hooks
 * @interface wike 及接口说明 https://wiki.umu.work/pages/viewpage.action?pageId=27597211
 */

import { getParticipateStatus } from '@umu/umu-api';
import { useState, useEffect, useCallback } from 'react';

import { config } from 'common';
const { NO_PERMISSION } = config;

export const useSubmissionTime = (sessionId: number, condition = true) => {
    const [participateStatus, setParticipateStatus] = useState({
        accept_submission_time: 0,
        participate_status: 0,
        refuse_submission_time: 0,
    });
    const [submissionTimePermission, setTimePermission] = useState(false);
    const [isSubmissionTimeLoading, setLoading] = useState(true);
    const onGetParticipateStatus = useCallback(async () => {
        const newParticipateStatus = await getParticipateStatus({ session_id: sessionId });
        if (newParticipateStatus) {
            setParticipateStatus(newParticipateStatus);
            setTimePermission(NO_PERMISSION.indexOf(newParticipateStatus.participate_status) > -1);
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        if (condition) {
            onGetParticipateStatus();
        }
    }, [sessionId]);

    return { submissionTimePermission, participateStatus, isSubmissionTimeLoading, onGetParticipateStatus };
};
